$.widget.bridge('uibutton', $.ui.button)


$(function () {
  // console.log(12);
  // $('[data-toggle="popover"]').popover({
  //     container: 'body'
  // })


  $('#firstButton').popover({
    container: "body",
    html: true,
    content: function () {
      return '<div class="popover-message">' + $(this).data("message") + '</div>';
    }
  });
})



$('body').on('keydown', 'input, select, textarea,button', function (e) {
  var self = $(this),
    form = self.parents('form:eq(0)'),
    focusable, next;
  if (e.keyCode == 13) {
    focusable = form.find('input,a,select,textarea').filter(':visible');
    next = focusable.eq(focusable.index(this) + 1);
    console.log(next);
    if (next.length) {
      next.focus();
    } else {
      $("#btnSubmit").click();
    }
    return false;
  }
});



